<div class="imagebox" style="display: inline-block; position: relative; cursor: pointer" *ngIf="(myimage|async) && (imageData|async)" (click)="open()">
  <img [src]="imageData|async" loading="lazy" [style.max-height]="thumb_max_height+'px'"/>
  <div class="detailsIcon">
    <svg-icon>suche</svg-icon>
  </div>
</div>
